import { defineVariant, VariantDefinition } from '@tanium/style-system';
import {
  PrimaryDisabledFill,
  PrimaryDisabledText,
  SecondaryDisabledBorder,
  SecondaryDisabledFill,
  SecondaryDisabledText,
} from './themeDefinitions';
import { ButtonVariant } from './types';
import { VARIANT_LINK, VARIANT_PRIMARY } from './variantTypes';

const commonStyles: VariantDefinition = {
  boxShadow: 'none',
  cursor: 'not-allowed',
};

export const disabledVariant = defineVariant<Exclude<ButtonVariant, typeof VARIANT_LINK>>(
  {
    primary: {
      bg: PrimaryDisabledFill,
      color: PrimaryDisabledText,
      borderColor: 'transparent',
      ...commonStyles,
    },
    secondary: {
      bg: SecondaryDisabledFill,
      color: SecondaryDisabledText,
      borderColor: SecondaryDisabledBorder,
      ...commonStyles,
    },
  },
  { defaultVariant: VARIANT_PRIMARY },
);
